"use client";

import { useLocale, useTranslations } from "next-intl";
import MyImage from "../image_layout/my_image";
import LanguageSwitcher from "../languageSwitch";
import { IoHome, IoLocationOutline } from "react-icons/io5";
import { MdMedicalServices, MdOutlineEmail } from "react-icons/md";
import { IoMdCall } from "react-icons/io";
import { IoMenuOutline } from "react-icons/io5";

import MyDivider from "../ui_tools/divider";
import Link from "next/link";
import NavigationBar from "./nav_container/nav_container";
import { useState } from "react";
import {
  NavLinkDropPagesMobile,
  NavlinkHome,
  NavLinkPages,
} from "./nav_links/nav_links";
import { FaPeopleRoof, FaRegNewspaper } from "react-icons/fa6";
import { BsDiagram2Fill } from "react-icons/bs";
import { GiThreeFriends } from "react-icons/gi";
import { RiContactsBook3Line } from "react-icons/ri";
import { usePathname } from "next/navigation";
import { FaBoxes } from "react-icons/fa";

export default function Header() {
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  const t = useTranslations("header");
  const s = useTranslations("activities");
    const l = useTranslations("about");

  const pathName = usePathname();

  const currentLocale = useLocale();

  // console.log(
  //   "P A T H --> ",
  //   pathName,
  //   "-------",
  //   currentLocale,
  //   pathName.startsWith(`/${currentLocale}/activities`)
  // );

  return (
    <div className="z-50 flex flex-col w-full fixed top-0 left-0    ">
      {/* header */}
      <div
        className={`py-2 px-2 bg-white   border-b border-slate-200  items-center justify-between transition-all duration-200 w-full shadow-2xl shadow-[#09871b]/20 lg:px-14  ${pathName.startsWith(`/${currentLocale}/activities`) ? "flex lg:hidden " : "flex"} ${pathName.startsWith(`/${currentLocale}/board`) ? "flex lg:hidden " : "flex"} ${pathName.startsWith(`/${currentLocale}/login`) ? "flex lg:hidden " : "flex"} ${pathName.startsWith(`/${currentLocale}/office`) ? "flex lg:hidden " : "flex"} `}
      >
        {/* logo & language */}
        <div className="flex gap-4 items-center  ">
          <Link
            href={"/"}
            className="h-[5vh] w-[35vw]  md:w-[12vw] lg:w-[8vw] "
          >
            <MyImage alt="" imgPath="/images/l.png" />
          </Link>
          <LanguageSwitcher className="hidden md:flex " />
          {/* <div className="hidden md:flex ">
            <p className="text-[#9d9d9d] text-base ">{t("slogan")}</p>
          </div> */}
        </div>

        {/* adress */}
        <div className="hidden items-center gap-8 lg:flex  ">
          <div className="flex items-center gap-2">
            <IoLocationOutline className="text-[#009900] text-2xl " />
            <MyDivider className="h-8 w-[1px] " />
            <div className="pl-1">
              <p className=" text-[#9d9d9d] md:text-xs lg:text-base ">Bureau principal</p>
              <p className="text-[#111] text-[14px] ">
                6,av Nyarambe,Q yambi yaya,Bunia RDC
              </p>
            </div>
          </div>

          <div className="flex items-center gap-2">
            <MdOutlineEmail className="text-[#009900] text-2xl " />
            <MyDivider className="h-8 w-[1px] " />
            <div className="pl-1">
              <p className=" text-[#9d9d9d] md:text-xs lg:text-base ">
                Ecrivez-nous sur email
              </p>
              <p className="text-[#111] text-[14px] ">info@cadimebu.net</p>
            </div>
          </div>

          <div className="flex items-center gap-2">
            <IoMdCall className="text-[#009900] text-2xl " />
            <MyDivider className="h-8 w-[1px] " />
            <div className="pl-1">
              <p className=" text-[#9d9d9d] md:text-xs lg:text-base ">Appellez-nous sur</p>
              <p className="text-[#111] text-[14px] ">(243) 972491975</p>
            </div>
          </div>
        </div>

        {/* menu mobile */}
        <div
          onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
          className="lg:hidden h-8 w-14 flex justify-center items-center  "
        >
          <IoMenuOutline className="text-[#111] text-4xl " />
        </div>
      </div>

      {/* MOBILE NAVIGATION MENU */}
      <div
        onClick={(e) => {
          if (e.target === e.currentTarget)
            setIsMobileMenuOpen(!isMobileMenuOpen);
        }}
        className={`min-h-screen flex bg-[#111]/10 backdrop-blur-lg w-full overflow-hidden transition-all duration-300 fixed top-0 left-0 ${
          isMobileMenuOpen
            ? " opacity-100 pointer-events-auto  "
            : " opacity-0 pointer-events-none  "
        } `}
      >
        <div
          className={`w-[70vw] ml-auto bg-[#09871b]  items-start rounded-bl-md shadow-2xl shadow-[#09871b]/20 flex flex-col justify-between  px-4 py-6 transition-all duration-300  ${
            isMobileMenuOpen
              ? " opacity-100 translate-x-0  "
              : " opacity-50 translate-x-30 "
          } `}
        >
          <div className="h-[18vh] flex justify-center w-full ">
            <div className="h-[12vh] w-full bg-white rounded-md md:w-full lg:w-[8vw] ">
              <MyImage alt="" imgPath="/images/l.png" />
            </div>
          </div>

          <div onClick={() => setIsMobileMenuOpen(false)} className="w-full">
            <NavlinkHome
              classN=" rounded-sm  "
              Icon={IoHome}
              label={t("menu.home")}
              url={`/`}
            />
          </div>

          <div onClick={() => setIsMobileMenuOpen(false)} className="w-full">
            <NavLinkDropPagesMobile
              classN=" "
              hasDropDown
              Icon={FaPeopleRoof}
              label={t("menu.about.we")}
              url={`/about`}
                 anchor="/about/"
        anchor2="/about/team_page"
        anchor3="/about/#service"
        subLabel={l("link.a")}
        subLabel2={l("link.b")}
        subLabel3={l("link.c")}
        isMobile
            />
          </div>

          <div onClick={() => setIsMobileMenuOpen(false)}>
            {/* <NavLinkDropPagesMobile
              classN=" "
              hasDropDown
              Icon={MdMedicalServices}
              label={t("menu.activities")}
              url={`/activities`}
              anchor="/activities"
              anchor2="/activities/store"
              anchor3="/activities/#services"
              subLabel={s("link")}
              subLabel2={s("link2")}
              subLabel3={s("link3")}
            /> */}
             <NavLinkPages
              classN=" rounded-sm  "
              Icon={FaBoxes}
              label={s("link2")}
              url={`/activities/store`}
            />
          </div>

          <div onClick={() => setIsMobileMenuOpen(false)}>
            {" "}
            <NavLinkPages
              Icon={BsDiagram2Fill}
              label={t("menu.organisation")}
              url={"/organisation"}
            />
          </div>

          <div onClick={() => setIsMobileMenuOpen(false)}>
            {" "}
            <NavLinkPages
              Icon={GiThreeFriends}
              label={t("menu.partners")}
              url={"/partners"}
            />
          </div>

          <div onClick={() => setIsMobileMenuOpen(false)}>
            {" "}
            <NavLinkPages
              Icon={FaRegNewspaper}
              label={t("menu.news")}
              url={"/events"}
            />
          </div>

          <div onClick={() => setIsMobileMenuOpen(false)}>
            {" "}
            <NavLinkPages
              Icon={RiContactsBook3Line}
              label={t("menu.contact")}
              url={"/contact"}
            />
          </div>

          {/* adress */}
          <div className="h-[18vh] w-full flex flex-col justify-end gap-2 ">
            <div className="flex items-center gap-2">
              <IoLocationOutline className="text-white text-[24px] " />
              <MyDivider className="h-5" />
              <p className="text-white text-sm ">
                6,av Nyarambe,Q yambi yaya,Bunia RDC
              </p>
            </div>
            <div className="flex items-center gap-2">
              <MdOutlineEmail className="text-white text-[24px] " />
              <MyDivider className="h-5" />
              <p className="text-white text-sm ">info@cadimebu.net</p>
            </div>
            <Link href={"tel()"} className="flex items-center gap-2">
              <IoMdCall className="text-white text-[24px] " />
              <MyDivider className="h-5" />
              <p className="text-white text-base ">(243) 972491975</p>
            </Link>
          </div>
        </div>
      </div>

      {/* menu */}
      <div className="w-full flex justify-center ">
        <NavigationBar />
      </div>
    </div>
  );
}
